//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      rowStyleOption: {
        stripe: true,
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          return "table-body-cell-class";
        },
      },
      columns: [
        {
          field: "name",
          key: "a",
          title: "店铺名称",
          align: "left",
          fixed: "left",
          width: 150,
        },
        {
          field: "date",
          key: "b",
          title: "所属区域",
          width: 100,
        },
        {
          field: "cyl",
          key: "c",
          title: "差异率",
          width: 100,
        },
        {
          title: "202112",
          children: [
            {
              field: "hobby",
              key: "d",
              title: "成本合计",
              width: 100,
            },
            {
              field: "hobby",
              key: "e",
              title: "实收金额合计",
              width: 100,
            },
            {
              field: "maoli",
              key: "f",
              title: "整体毛利",
              width: 100,
            },
          ],
        },
        {
          title: "202012",
          children: [
            {
              field: "hobby",
              key: "g",
              title: "成本合计",
              width: 100,
            },
            {
              field: "hobby",
              key: "h",
              title: "实收金额合计",
              width: 100,
            },
            {
              field: "maoli",
              key: "i",
              title: "整体毛利",
              width: 100,
            },
          ],
        },
        {
          field: "cyl",
          key: "j",
          title: "差异率",
          width: 100,
        },
      ],
      tableData: [
        {
          name: "北碚周大生1店",
          date: "大足区域",
          cyl: "-3.02%",
          hobby: "1654512.00",
          maoli: "45%",
        },
      ],
    };
  },
};
